import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User clicked an action in the canvas group toolbar',
  name: 'canvas_group_toolbar_action_clicked',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The group toolbar action that was clicked',
      name: 'action_taken',
      required: true,
      type: 'enum',
      values: ['prompt', 'smart_resize', 'ungroup', 'platform_preview', 'save_to_workspace', 'crop'],
    },
  ],
};

export default META;
